module.exports = __webpack_public_path__ + "static/media/AK_1.b9f35ea5.jpeg";